export default {
  increment: 'increment',
  decrement: 'decrement',
  SIDEBAR_OPEN: 'SIDEBAR_OPEN',
  SIDEBAR_CLOSE: 'SIDEBAR_CLOSE',
  SEARCH: 'SEARCH',
  ADD_USERS: 'ADD_USERS',
  REMOVE_USERS: 'REMOVE_USERS',
  FETCH_INSTITUTION: 'FETCH_INSTITUTION',
  CHECK_INSTITUTION: 'CHECK_INSTITUTION',
  USER_LOGIN: 'USER_LOGIN',
  UPDATE_USER: 'UPDATE_USER',
  FETCH_ROLES: 'FETCH_ROLES',
  FETCH_ROLE: 'FETCH_ROLE',
  ADD_ROLE: 'ADD_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  FETCH_PERMISSIONS: 'FETCH_PERMISSIONS',
  LOADING: 'LOADING',
  TOASTS_SHOW_TOAST: 'TOASTS_SHOW_TOAST',
  TOASTS_DISMISS_TOAST: 'TOASTS_DISMISS_TOAST',
  REGENERATE_SESSION_TOKEN: 'REGENERATE_SESSION_TOKEN',
};
